var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBox({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.328 4H2.64C2.46933 4 2.32 4.07467 2.192 4.224C2.064 4.352 2 4.50133 2 4.672V7.328C2 7.49867 2.064 7.65867 2.192 7.808C2.32 7.936 2.46933 8 2.64 8H3.312V19.328C3.312 19.52 3.376 19.68 3.504 19.808C3.632 19.936 3.792 20 3.984 20H19.984C20.176 20 20.336 19.936 20.464 19.808C20.592 19.68 20.656 19.52 20.656 19.328V8H21.328C21.52 8 21.68 7.936 21.808 7.808C21.936 7.68 22 7.52 22 7.328V4.672C22 4.48 21.936 4.32 21.808 4.192C21.68 4.064 21.52 4 21.328 4ZM19.312 18.656H4.656V8H19.312V18.656ZM20.656 6.656H3.312V5.312H20.656V6.656ZM9.328 10.656C9.328 10.464 9.392 10.304 9.52 10.176C9.648 10.048 9.808 9.984 10 9.984H14C14.192 9.984 14.352 10.048 14.48 10.176C14.608 10.304 14.672 10.464 14.672 10.656C14.672 10.848 14.608 11.008 14.48 11.136C14.352 11.264 14.192 11.328 14 11.328H10C9.808 11.328 9.648 11.264 9.52 11.136C9.392 11.008 9.328 10.848 9.328 10.656Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/Box.8d10059edb860187047634f6d5db228f.svg";
export { ForwardRef as ReactComponent };